import { ShieldCheck, MapPin, Sparkles } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import Reveal from "./Reveal";
import beamy from "@/assets/beamy.png";

const AboutSection = () => {
  const { t } = useLanguage();

  const points = [
    { icon: ShieldCheck, titleKey: "about.point1", descKey: "about.point1desc" },
    { icon: MapPin, titleKey: "about.point2", descKey: "about.point2desc" },
    { icon: Sparkles, titleKey: "about.point3", descKey: "about.point3desc" },
  ];

  return (
    <section className="py-20 bg-paper-dark">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-16 items-center max-w-5xl mx-auto">
          <Reveal className="relative flex justify-center">
            <div
              aria-hidden
              className="absolute inset-0 m-auto w-56 h-56 rounded-full pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(108,77,255,0.18) 0%, transparent 70%)" }}
            />
            <div className="relative">
              <img src={beamy} alt="" aria-hidden className="w-40 sm:w-48 object-contain animate-float" />
              <div
                className="absolute -right-6 sm:-right-10 top-2 max-w-[190px] bg-paper-light border border-paper-ink/10 rounded-2xl rounded-bl-md px-4 py-3 shadow-[0_10px_30px_-16px_rgba(20,19,17,0.4)]"
                style={{ transform: "rotate(1.6deg)" }}
              >
                <p className="font-display italic text-[15px] leading-snug text-paper-ink">{t("beamy.bubble")}</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="eyebrow mb-4" style={{ color: "#6C4DFF" }}>{t("eyebrow.about")}</div>
            <h2 className="font-display text-4xl md:text-5xl text-paper-ink mb-5 leading-[1.05]">
              {t("about.title1")}
              <em className="italic text-violet-solid">{t("about.title2")}</em>.
            </h2>
            <p className="text-paper-ink/70 leading-relaxed mb-4">{t("about.p1")}</p>
            <p className="text-paper-ink/70 leading-relaxed mb-8">{t("about.p2")}</p>

            <ul className="grid sm:grid-cols-3 gap-4">
              {points.map((p, i) => (
                <li key={i} className="flex sm:block items-start gap-3">
                  <p.icon className="h-5 w-5 text-violet-solid sm:mb-2 flex-shrink-0" aria-hidden />
                  <div>
                    <div className="text-sm font-semibold text-paper-ink">{t(p.titleKey)}</div>
                    <div className="text-[13px] text-paper-ink/60 leading-relaxed">{t(p.descKey)}</div>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
